import { createReducer } from 'store/createReducer';
import { Alerts } from 'models/Alerts';

const reducer = {};

export const initialState: Alerts = {
  sitewideAlert: [],
  paymentAlert: [],
  checkoutAlert: [],
  sitewideWithoutProductPageAlert: []
};

export const alerts = createReducer(initialState, reducer);
